import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CopyableButton from '@src/components/CopyableButton';
import { StyledPasswordBox } from './index.style';

const PasswordBox = ({ text, password = true, bg = '' }) => {
  const [visible, setVisible] = useState(!password);

  return (
    <StyledPasswordBox>
      <TextField
        type={visible ? 'text' : 'password'}
        value={text}
        variant="outlined"
        size="small"
        fullWidth
        InputProps={{
          readOnly: true,
          style: { backgroundColor: bg },
          endAdornment: (
            <InputAdornment position="end" className="contain">
              <IconButton className="icon-button">
                <CopyableButton color="#1E164ECC" content={text} />
              </IconButton>
              {password && (
                <>
                  <div className="divider" />
                  <IconButton onClick={() => setVisible(!visible)}>
                    {visible ? (
                      <Visibility sx={{ color: '#1E164ECC' }} />
                    ) : (
                      <VisibilityOff sx={{ color: '#1E164ECC' }} />
                    )}
                  </IconButton>
                </>
              )}
            </InputAdornment>
          ),
        }}
      />
    </StyledPasswordBox>
  );
};

export default PasswordBox;
